// extracted by mini-css-extract-plugin
export default {"root":"Tab_root__YWZ4I","active":"Tab_active__AclJB","placeHolderShimmer":"Tab_placeHolderShimmer__0c6Ud"};